import { Link } from "react-router-dom";
import Membresias from "./Membresias";

const footerLinks = [
  {
    title: "Secciones",
    links: [
      { label: "Inicio", href: "/" },
      { label: "Noticias", href: "/actualidad" },
      { label: "Aeropuertos", href: "/aeropuertos" },
      { label: "Aerolíneas", href: "/aerolineas" },
      { label: "Turismo", href: "/turismo" },
      { label: "Estadísticas", href: "/estadisticas" },
      { label: "Contacto", href: "/contacto" },
    ],
  },
  {
    title: "Temáticas",
    links: [
      { label: "Estadísticas", href: "/estadisticas" },
      { label: "Sostenibilidad", href: "/actualidad?categoria=Sostenibilidad" },
      { label: "Entrevistas", href: "/actualidad?categoria=Entrevistas" },
      { label: "Tendencias", href: "/actualidad?categoria=Tendencias" },
    ],
  },
  {
    title: "Proyecto",
    links: [
      { label: "Sobre Aviación Insight", href: "/sobre-mi" },
      { label: "Publicidad", href: "/publicidad" },
      { label: "Newsletter", href: "/#newsletter" },
      { label: "Política de privacidad", href: "/" },
    ],
  },
];

const socialLinks = [
  { icon: "ri-facebook-fill", href: "https://www.facebook.com/profile.php?id=61591088725425", label: "Facebook" },
  { icon: "ri-instagram-line", href: "https://www.instagram.com/aviacioninsightrd?utm_source=qr", label: "Instagram" },
  { icon: "ri-twitter-x-line", href: "https://x.com/aviacioninsight?s=11&t=_ylQO8qtabGaqp-OhtGSBA", label: "X" },
];

export default function Footer() {
  return (
    <footer className="bg-[#071529] text-white">
      <Membresias />

      {/* Main footer */}
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/7a6028ad-3552-457e-be8d-c77b0b9450c6/f53e079f-ed10-4acb-9346-bd1da877b1e6_apple-touch-icon.png?v=bcaf5114cecaf378812bbdd6646af1ba"
                alt="Aviación Insight RD"
                className="h-12 w-12 object-cover"
              />
              <div>
                <p className="text-white/90 font-bold text-lg leading-tight tracking-wide whitespace-nowrap" style={{ fontFamily: "'Sora', sans-serif" }}>
                  AVIACIÓN INSIGHT RD
                </p>
                <p className="text-slate-400 text-xs tracking-widest uppercase" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  por Carmen Bretón
                </p>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-sm" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              El periódico digital especializado en el sector aeronáutico de República Dominicana y el Caribe
            </p>
            {/* Social links */}
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center bg-blue-900/40 hover:bg-blue-600 rounded-lg text-blue-300 hover:text-white transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-white/90 font-semibold text-sm mb-4 tracking-wider uppercase" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                {col.title}
              </h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-slate-400 hover:text-blue-300 text-sm transition-colors cursor-pointer" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-blue-950">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-sm text-center sm:text-left" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            © 2026 <strong className="text-slate-400">Aviación Insight RD</strong>. Todos los derechos reservados. · por Carmen Bretón
          </p>
          <p className="text-slate-600 text-xs flex items-center gap-1.5" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            <i className="ri-code-box-line text-slate-500 w-4 h-4 flex items-center justify-center" />
            Powered by
            <span className="text-slate-400 font-medium">InnoFlex Technology</span>
          </p>
        </div>
      </div>
    </footer>
  );
}